import { EmailThreadModel } from "../schema/email-thread.model";
import { MongoBaseContainer } from "./mongo-base-container.model";

export class EmailThreadContainer extends MongoBaseContainer{
    email_thread: EmailThreadModel
}